import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import HowWeBuiltIt from "./pages/HowWeBuiltIt";
import Careers from "./pages/Careers"; 
import Contact from "./pages/Contact";

export default function App() {
  return (
    <HelmetProvider>
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/howwebuiltit" element={<HowWeBuiltIt />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
    </HelmetProvider>
  );
}